import { render } from "./TabsProjects.vue?vue&type=template&id=540d6c50&scoped=true"
import script from "./TabsProjects.vue?vue&type=script&lang=js"
export * from "./TabsProjects.vue?vue&type=script&lang=js"

import "./TabsProjects.vue?vue&type=style&index=0&id=540d6c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540d6c50"]])

export default __exports__